class TSSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.currentSlide = 1;
    this.slider = this.querySelector('[id^="Slider-"]');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.update();
    window.addEventListener('resize', this.update.bind(this));
    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    console.log(this.currentSlide);
    
    event.preventDefault();
    if (event.currentTarget.name === 'previous' && this.currentSlide > 1) {
      this.currentSlide -= 1;
    } else if (event.currentTarget.name === 'next' && this.currentSlide < this.maxLength) {
      this.currentSlide += 1;
    }
    this.scrollToSlide(this.currentSlide);
  }

  scrollToSlide(index) {
    this.slider.scrollTo({
      left: this.querySelector(`[id^="Slide-"]:nth-child(${index})`).offsetLeft,
      behavior: 'smooth'
    });
  }

  update() {
    const items = this.querySelectorAll('[id^="Slide-"]');
    const scrollLeft = this.slider.scrollLeft;
    const clientWidth = this.slider.clientWidth;
    const blockWidth = items[0]?.offsetWidth ?? 0;
    const gap = window.innerWidth < 750 ? 16 : 24;
    const hasScroll = this.slider.scrollWidth > clientWidth;
      
    this.maxLength = items.length - (Math.floor(clientWidth / blockWidth) - 1);
    this.currentSlide = Math.round(scrollLeft / (blockWidth + gap)) + 1;

    this.prevButton.toggleAttribute("disabled", this.currentSlide == 1);
    this.nextButton.toggleAttribute("disabled", this.currentSlide == this.maxLength);

    this.prevButton.classList.toggle("hidden", !hasScroll);
    this.nextButton.classList.toggle("hidden", !hasScroll);
  }
}

if (document.querySelector("ts-slider-component")) {
  customElements.define("ts-slider-component", TSSliderComponent);
}